module.exports = __webpack_public_path__ + "static/1_1_defineai_ES-35b2b89a0bab0396ac506f3e5ed3437b.svg";